import { isNode } from "./environment";
/**
 * Not null, undefined, or empty string.
 */
export const notNullish = (value) => !!value || value === 0 || value === false;
/**
 * Convert a scalar-or-array parameter to array.
 */
export function vectorize(v) {
    if (v === null || v === undefined) {
        return Array();
    }
    return Array.isArray(v) ? v : [v];
}
export function chunk(arr, len) {
    const chunks = [];
    const n = arr.length;
    let i = 0;
    while (i < n) {
        chunks.push(arr.slice(i, (i += len)));
    }
    return chunks;
}
export const flatten = (arr) => arr.reduce((flat, toFlatten) => flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten), []);
export const fromEntries = (iterable) => {
    return [...iterable].reduce((obj, [key, val]) => {
        obj[key] = val;
        return obj;
    }, {});
};
export const cookieJar = () => isNode ? {} : fromEntries(document.cookie.split("; ").map(x => x.split("=")));
/**
 * Make a mostly random id for use within sub-documents to keep things straight.
 * This function won't work at scale, but it doesn't need to. It's fine!
 */
export function makeId(length = 5) {
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let text = "";
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
/**
 * Super simple group by function that is typed properly with generics. Keeps us
 * from having to outsource this super simple problem then fight with the types.
 */
export const groupBy = (input, by) => {
    return input.reduce((p, c) => {
        const k = by(c);
        p[k] = p[k] || [];
        p[k].push(c);
        return p;
    }, {});
};
/**
 * Super simple key by function that is typed properly with generics. Keeps us
 * from having to outsource this super simple problem then fight with the types.
 */
export const keyBy = (input, by) => {
    return input.reduce((p, c) => ({ ...p, [by(c)]: c }), {});
};
export const flattenObj = (input) => {
    return Object.assign({}, ...input);
};
export const remapObj = (input, by) => {
    return Object.entries(input)
        .map(([k, v]) => ({ [k]: by(v) }))
        .reduce((p, c) => ({ ...p, ...c }), {});
};
/**
 * Creates a duplicate-free version of `iter`, using a `Map`-style key or the
 * result of `keyFn` equality comparisons, in which only the first occurence of
 * each element is kept.
 */
export const unique = (iter, keyFn) => iter.reduce(({ arr, set }, v) => {
    const k = keyFn ? keyFn(v) : v;
    if (!set.has(k)) {
        arr.push(v);
        set.add(k);
    }
    return { arr, set };
}, { arr: [], set: new Set() }).arr;
/**
 * Consistent key sorter for use with JSON.stringify and equivalents.
 */
export function sortedKeyReplacer(_, value) {
    return value instanceof Object && !(value instanceof Array)
        ? Object.keys(value)
            .sort()
            .reduce((sorted, k) => {
            sorted[k] = value[k];
            return sorted;
        }, {})
        : value;
}
//# sourceMappingURL=util.js.map